// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__gnELv","photo":"Quote_photo__qkKx5","name":"Quote_name__CxOZc"};